export enum OPERATION_RESULT {
    'SUCCESSFUL' = 'SUCCESSFUL',
    'FAILED' = 'FAILED'
}